import defer from 'promise-defer';

export function checkInternetConnection() {
  const Offline = window.Offline;

  let deferred = defer();

  const upFunc = function() {
    deferred.resolve();
    unbind();
  };

  const downFunc = function() {
    deferred.reject();
    unbind();
  };

  const unbind = function() {
    Offline.off('confirmed-up');
    Offline.off('confirmed-down');
  };

  Offline.on('confirmed-up', upFunc);
  Offline.on('confirmed-down', downFunc);

  Offline.check();

  return deferred.promise;
}



// WEBPACK FOOTER //
// ./src/tools/internet-connection-checker.js